import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';
import View from '../view';

interface IDividerProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 内容位置
   * @default center
   */
  position?: 'center' | 'left' | 'right';
  /**
   * 是否使用虚线
   * @default false
   */
  dashed?: boolean;
}

const Divider: FC<PropsWithChildren<IDividerProps>> = ({ className, position = 'center', dashed = false, children }) => {
  const rootClass = classNames(
    'ink-divider',
    {
      [`ink-divider--content-${position}`]: !!position,
      'ink-divider--dashed': dashed,
    },
    className,
  );
  return <View className={rootClass}>{children}</View>;
};

export default Divider;
